import { React, useState  } from 'react'
import "../../../styles/registrado/FechasCapacitaciones.css"

function FechasCapacitaciones() {

	const [hovered0, setHovered0] = useState(false);
	const [hovered1, setHovered1] = useState(false);
	const [hovered2, setHovered2] = useState(false);
	const [hovered3, setHovered3] = useState(false);

  	const handleMouseEnter0 = () => {
  	  setHovered0(true);
  	};

	  const handleMouseEnter1 = () => {
  	  setHovered1(true);
  	};

	  const handleMouseEnter2 = () => {
  	  setHovered2(true);
  	};

	  const handleMouseEnter3 = () => {
  	  setHovered3(true);
  	};

  	const handleMouseLeave0 = () => {
  	  setHovered0(false);
  	};

	  const handleMouseLeave1 = () => {
  	  setHovered1(false);
  	};

	  const handleMouseLeave2 = () => {
  	  setHovered2(false);
  	};

	  const handleMouseLeave3 = () => {
  	  setHovered3(false);
  	};

  return (
		<div className="calendar-frame-capacitaciones center-capacitaciones">
			<div 
				className="day-frame-capacitaciones center-capacitaciones real-capacitaciones" 
				id='one-capacitaciones'
				onMouseEnter={handleMouseEnter0}
   			   	onMouseLeave={handleMouseLeave0}
			>
				<a className="day-label-capacitaciones center-capacitaciones" href='https://www.youtube.com/channel/UCh91SYAS4QN8q8xkVJ_wq2w' target='blank'>{hovered0 ? "Haga clic para ingresar a la capacitación." : "DD/MM/AA - Capacitacion sobre finanzas"}</a>
			</div>
			<div 
				className="day-frame-capacitaciones center-capacitaciones real-capacitaciones" 
				id='two-capacitaciones'
				onMouseEnter={handleMouseEnter1}
   			   	onMouseLeave={handleMouseLeave1}
			>
				<a className="day-label-capacitaciones center-capacitaciones" href='https://www.youtube.com/channel/UCh91SYAS4QN8q8xkVJ_wq2w' target='blank'>{hovered1 ? "Haga clic para ingresar a la capacitación." : "DD/MM/AA - Capacitacion sobre finanzas"}</a>
			</div>
			<div 
				className="day-frame-capacitaciones center-capacitaciones real-capacitaciones" 
				id='three-capacitaciones'
				onMouseEnter={handleMouseEnter2}
   			   	onMouseLeave={handleMouseLeave2}
			>
				<a className="day-label-capacitaciones center-capacitaciones" href='https://www.youtube.com/channel/UCh91SYAS4QN8q8xkVJ_wq2w' target='blank'>{hovered2 ? "Haga clic para ingresar a la capacitación." : "DD/MM/AA - Capacitacion sobre finanzas"}</a>
			</div>
			<div 
				className="day-frame-capacitaciones center-capacitaciones real-capacitaciones" 
				id="four-capacitaciones"
				onMouseEnter={handleMouseEnter3}
   			   	onMouseLeave={handleMouseLeave3}
			>
				<a className="day-label-capacitaciones center-capacitaciones" href='https://www.youtube.com/channel/UCh91SYAS4QN8q8xkVJ_wq2w' target='blank'>{hovered3 ? "Haga clic para ingresar a la capacitación." : "DD/MM/AA - Capacitacion sobre finanzas"}</a>
			</div>
		</div>
  )
}

export default FechasCapacitaciones